import React from 'react';
import './Hero.css';
import { CONTACT_INFO } from '../config';

const Hero = () => {
  // Check if today is the 15th of the month
  const today = new Date();
  const isFifteenth = today.getDate() === 15;

  return (
    <section id="home" className="hero">
      {isFifteenth && (
        <div className="promo-banner">
          <div className="promo-content">
            <span className="promo-icon">🎉</span>
            <div className="promo-text">
              <span className="promo-title">Özel Gün!</span>
              <span className="promo-subtitle">%50 Bedava Çiğköfte</span>
            </div>
            <span className="promo-badge">Sadece Bugün</span>
          </div>
        </div>
      )}
      <div className="hero-container">
        <div className="hero-left">
          <div className="hero-image-wrapper">
            <img 
              src="/images/cigkofte-durum.jpg" 
              alt="Resume Çiğköfte Dürüm" 
              className="hero-main-image"
            />
            <div className="image-badge">🌭 Özel Lezzet</div>
            <div className="image-decoration"></div>
          </div>
        </div>

        <div className="hero-right">
          <h1 className="main-title">Türk Mutfağının En Özgün Tadı</h1>
          <h2 className="subtitle">Resume Çiğköfte'yle Her Anın Başında Lezzet!</h2>
          <p className="description">Geleneksel tarifler, modern sunuş. Her lokmada özgün tat ve aroma! 15 yıldır aynı kalite, aynı lezzet.</p>
          
          <div className="features-mini">
            <div className="mini-feature">✓ Taze Malzeme</div>
            <div className="mini-feature">✓ Hızlı Servis</div>
            <div className="mini-feature">✓ Uygun Fiyat</div>
          </div>

          <div className="button-group">
            <button className="cta-button">📞 {CONTACT_INFO.phone}</button>
            <button className="secondary-button">📋 Menüyü Gör</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
